import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["checked", "checkedIcon", "className", "defaultChecked", "disabled", "error", "id", "name", "label", "onChange"];
import React, { forwardRef, useMemo, useState, useCallback } from 'react';
import { useComponentTheme } from '../../utils/hooks';
import { SelectorLabel } from '../SelectorLabel';
import { useCheckboxClassName } from './hooks/useCheckboxClassName';
import { CheckboxInput, CheckboxCheckmark, CheckboxRoot } from './style';
import { checkboxDefaultTheme } from './theme';
import { generateId } from '../../utils';
import { CHECKBOX_CLASS_PREFIX, checkboxIdPrefix } from './constants';
export var Checkbox = forwardRef(function Checkbox(_ref, ref) {
  var checked = _ref.checked,
      checkedIcon = _ref.checkedIcon,
      className = _ref.className,
      defaultChecked = _ref.defaultChecked,
      disabled = _ref.disabled,
      error = _ref.error,
      propsId = _ref.id,
      name = _ref.name,
      label = _ref.label,
      onChange = _ref.onChange,
      restProps = _objectWithoutProperties(_ref, _excluded);

  var theme = useComponentTheme(CHECKBOX_CLASS_PREFIX, checkboxDefaultTheme);
  var id = generateId(propsId, checkboxIdPrefix);
  var classOverride = useCheckboxClassName(CHECKBOX_CLASS_PREFIX, className, disabled, checked, error);

  var _useState = useState(checked !== undefined ? !!checked : !!defaultChecked),
      _useState2 = _slicedToArray(_useState, 2),
      nativelyChecked = _useState2[0],
      setNativelyChecked = _useState2[1];

  var reallyChecked = checked !== undefined ? checked : nativelyChecked;
  var handleOnChange = useCallback(function (event) {
    if (onChange) {
      onChange(event);
    }

    setNativelyChecked(event.target.checked);
  }, [onChange, setNativelyChecked, nativelyChecked]);
  var typographyProps = useMemo(function () {
    return {
      paragraph: true,
      large: true
    };
  }, []);
  return React.createElement(CheckboxRoot, Object.assign({}, restProps, {
    className: classOverride.Root,
    disabled: disabled,
    theme: theme,
    htmlFor: id,
    reallyChecked: reallyChecked
  }), React.createElement(CheckboxInput, {
    className: classOverride.Input,
    checked: checked,
    defaultChecked: defaultChecked,
    checkedIcon: checkedIcon,
    disabled: disabled,
    id: id,
    name: name,
    onChange: handleOnChange,
    ref: ref,
    theme: theme,
    type: "checkbox"
  }), React.createElement(CheckboxCheckmark, {
    checked: checked,
    checkedIcon: checkedIcon,
    className: classOverride.Checkmark,
    disabled: disabled,
    theme: theme,
    hasLabel: !!label
  }), !!label && React.createElement(SelectorLabel, {
    disabled: disabled,
    error: error,
    className: classOverride.Label,
    typographyProps: typographyProps
  }, label));
});
Checkbox.displayName = CHECKBOX_CLASS_PREFIX;
Checkbox.defaultProps = {
  checkedIcon: 'tick',
  disabled: false
};